<template>
  <div class="AppSsmlEditor">
    <quill-editor
        ref="quillEditor"
        :class="warning || blanksWarning ? 'warningEditor' : ''"
        :options="editorOptions"
        v-model="inputVal"
        @change="handleChange"
        @copy.native="handleCopy"
    ></quill-editor>
    <div v-if="warning" class="warningTxt">不得超过300字</div>
    <div v-if="blanksWarning" class="warningTxt">请输入</div>
  </div>
</template>

<script>
import {quillEditor} from "vue-quill-editor";

export default {
  name: "AppSsmlEditor",
  components: {quillEditor},
  props: {
    showForRead: {
      type: Boolean,
      default: false,
    },
    audioText: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    blankWarning: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputVal: "",
      inputValArr: [],
      textLength: null,
      editorOptions: {
        placeholder:
            "请输入你的内容，选择音频相关的属性，点击生成音频后方可试听",
        readOnly: this.showForRead
      },
      warning: false,
      lessonType: "",
      blanksWarning: false,
    };
  },
  watch: {
    textLength: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          this.warning = newValue > 300;
        }
      },
      deep: true,
      immediate: true,
    },
    audioText: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          this.inputVal = newValue;
        }
      },
      deep: true,
      immediate: true,
    },
    type: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          this.lessonType = newValue;
        }
      },
      deep: true,
      immediate: true,
    },
    blankWarning: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          this.blanksWarning = newValue;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.disabledEdit();
    this.blurEditor();
  },
  methods: {
    handleCopy(event) {
      let text = window.getSelection().toString();
      text = text.replaceAll("\n\n", "\n");
      event.preventDefault();
      event.clipboardData.setData('text/plain', text)
    },
    handleChange() {
      if (this.lessonType === "audioText") {
        this.$emit("handleChangeTitleAudio", this.inputVal);
      }
      if (this.lessonType === "question") {
        this.$emit("handleChange", this.inputVal);
      }
      if (this.lessonType === "explain") {
        this.$emit("handleChangeSayAudio", this.inputVal);
      }
      this.inputValArr = this.convertToObjects(this.inputVal);
      this.textLength = this.inputValArr.length;
      // if (this.lessonType === "question") {
      //   this.blanksWarning = this.textLength < 1;
      // }
      this.$nextTick(() => {
        this.disabledEdit();
      });
    },
    convertToObjects(val) {
      const objects = [];
      if (!val) {
        return objects;
      }
      const regex = /(<strong.*?>.*?<\/strong>)|./g;
      const result = val.match(regex);
      var newResult = [];
      for (let i = 0; i < result.length; i++) {
        if (result[i].trim().length > 1) {
          if (!result[i].includes("color: rgb(16, 104, 156)")) {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push(text);
          } else {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push("{{{" + text + "}}}");
          }
        } else {
          newResult.push(result[i]);
        }
      }
      const str = newResult.join("");
      const div = document.createElement("div");
      div.innerHTML = str;
      let newStr = div.textContent || div.innerText;

      const regex2 = /({{{.*?}}})|./g;
      const result2 = newStr.match(regex2);
      for (let i = 0; i < result2.length; i++) {
        const item = result2[i];
        if (item.length > 1) {
          const regex = /\{\{\{(.+?)\}\}\}/g;
          const match = item.replace(regex, "$1");
          if (match && match.length >= 2) {
            const extractedText = match.trim();
            const cha = extractedText.split("]")[1];
            const pinyin = extractedText.split("]")[0].split("[")[1];
            objects.push({cha: cha, pinyin: pinyin});
          }
        } else {
          objects.push({cha: item, pinyin: ""});
        }
      }
      return objects;
    },
    // handleConfirm(characterArr) {
    //   return characterArr
    //     .map((item, index) => {
    //       if (item.pinyin !== "") {
    //         if (index % 2 === 0) {
    //           return `<b style='color: #10689c;'> [${item.pinyin}]${item.cha} </b>`;
    //         } else {
    //           return `<b style='color: #10689c;background: transparent;'> [${item.pinyin}]${item.cha} </b>`;
    //         }
    //       } else {
    //         if (item.cha === " ") {
    //           return "&nbsp;";
    //         } else {
    //           return item.cha;
    //         }
    //       }
    //     })
    //     .join("");
    // },
    // 返回纯文本数组
    // convertToObjects(val) {
    //   const objects = [];
    //   if (!val) {
    //     return objects;
    //   }
    //   // 去掉p标签
    //   const inputValWithoutP = val
    //     .replace(/<\/?p>/g, "")
    //     .replace(/<span.*?>/g, "")
    //     .replace(/<\/?span>/g, "")
    //     .replace(/&nbsp;/g, " ");
    //   if (inputValWithoutP.trim().length < 1) {
    //     return objects;
    //   }
    //   const regex = /(<strong.*?>.*?<\/strong>)|./g;
    //   const result = inputValWithoutP.match(regex);
    //   for (let i = 0; i < result.length; i++) {
    //     const item = result[i];
    //     if (item.length > 1) {
    //       const regex = /<strong.*?>(.*?)<\/strong>/;
    //       const match = item.match(regex);
    //       if (match && match.length >= 2) {
    //         const extractedText = match[1].trim();
    //         const cha = extractedText.split("]")[1];
    //         const pinyin = extractedText.split("]")[0].split("[")[1];
    //         objects.push({ cha: cha, pinyin: pinyin });
    //       }
    //     } else {
    //       objects.push({ cha: item, pinyin: "" });
    //     }
    //   }
    //   return objects;
    // },
    // 多音字不可编辑部分
    disabledEdit() {
      let paragraphs = document.querySelectorAll("p");
      paragraphs.forEach(function (paragraph) {
        let strongArr = paragraph.querySelectorAll("strong");
        strongArr.forEach(function (strong) {
          if (getComputedStyle(strong).color === "rgb(16, 104, 156)") {
            strong.setAttribute("contenteditable", "false");
          }
        });
      });
    },
    //   输入框失去焦点
    blurEditor() {
      this.$nextTick(() => {
        const editor = this.$refs.quillEditor.quill;
        const length = editor.getLength();
        editor.setSelection(length, length);
        editor.blur();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.AppSsmlEditor {
  ::v-deep .ql-toolbar.ql-snow {
    display: none;
  }

  ::v-deep .ql-container.ql-snow {
    border: none;
  }

  ::v-deep .ql-editor {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    height: 150px !important;
    background: #ffffff;
  }

  ::v-deep .warningEditor {
    border: 1px solid red;
    border-radius: 4px;
    //height: 150px !important;
    //background: #ffffff;
  }

  ::v-deep .ql-editor.ql-blank::before {
    color: #c0c4cc;
    content: attr(data-placeholder);
    font-style: normal;
    font-size: 12px;
    left: 15px;
    pointer-events: none;
    position: absolute;
    right: 15px;
  }

  .warningTxt {
    color: #f56c6c;
    font-size: 12px;
  }
}
</style>
